import { useNavigate } from 'react-router-dom';
import { Tag, Badge, Card, CardHeader, CardBody, CardFooter } from '@caos/ca-component-library';
import { isRecentlyUpdated, timeAgo } from '../lib/marketplace';
import { Skill } from '../types';
import StarButton from './StarButton';
import './SkillCard.css';

const MAX_TAGS = 3;

interface SkillCardProps {
  skill: Skill;
}

export default function SkillCard({ skill }: SkillCardProps) {
  const navigate = useNavigate();
  const recent = isRecentlyUpdated(skill);
  const displayTags = skill.tags.filter((t) => t !== 'mcp-uploaded');
  const visibleTags = displayTags.slice(0, MAX_TAGS);
  const overflowCount = displayTags.length - MAX_TAGS;

  return (
    <div className="skill-card-wrapper" onClick={() => navigate(`/skills/${skill.id}`)}>
      <Card size="full">
        <CardHeader className="skill-card-header">
          <div className="skill-card-badge-row">
            {recent && (
              <Badge
                size="sm"
                shape="capsule"
                style={{ '--badge-bg': 'var(--recently-updated-bg)' } as React.CSSProperties}
              >
                Updated
              </Badge>
            )}
            <Badge
              size="sm"
              shape="capsule"
              style={{ '--badge-bg': 'var(--skills-primary)' } as React.CSSProperties}
            >
              Skill
            </Badge>
          </div>
          <h3 className="skill-card-name">{skill.name}</h3>
        </CardHeader>

        <CardBody className="skill-card-body">
          <p className="skill-card-description">{skill.description}</p>
          {skill.tags.length > 0 && (
            <div className="skill-card-tags">
              <span className="skill-card-tags-label">Tags</span>
              <div className="skill-card-tags-list">
                {visibleTags.map((tag) => (
                  <Tag key={tag} size="sm">
                    {tag}
                  </Tag>
                ))}
                {overflowCount > 0 && (
                  <span className="skill-card-tag-more">+{overflowCount}</span>
                )}
              </div>
            </div>
          )}
        </CardBody>

        <CardFooter className="skill-card-footer">
          <div className="skill-card-meta">
            <span className="skill-card-owner">{skill.owner}</span>
            <span className="skill-card-separator">&#183;</span>
            <span className="skill-card-version">v{skill.version}</span>
            <span className="skill-card-separator">&#183;</span>
            <span className="skill-card-updated">{timeAgo(skill.last_updated)}</span>
          </div>
          <StarButton itemId={skill.id} itemType="skill" />
        </CardFooter>
      </Card>
    </div>
  );
}
